import React from 'react'
import PropTypes from 'prop-types'
import { PromiseButtonIcon } from 'src/components/buttons'
import { FormContext } from 'src/contexts'
import { LocalizedText } from 'src/components/intl'
import { useIsFormValid, useIsFormDirty, useIsFormSubmitting, useIsFormDisabled, useHandler } from 'src/hooks'
import { SaveIcon } from '../icons'

export default function SubmitButton({ children, icon, ...props }) {
  const form = FormContext.use()
  const submitting = useIsFormSubmitting()
  const dirty = useIsFormDirty()
  const valid = useIsFormValid()
  const disabled = useIsFormDisabled()

  const canSubmit = !disabled && !submitting && dirty && valid

  const onClick = useHandler(e => e.preventDefault() || (canSubmit && form.submit()))

  return (
    <PromiseButtonIcon onClick={onClick} disabled={!canSubmit} icon={disabled ? 'lock' : icon} {...props}>
      {disabled ? <LocalizedText id="WEB_FORBIDDEN" /> : children}
    </PromiseButtonIcon>
  )
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.elementType,
}

SubmitButton.defaultProps = {
  icon: SaveIcon,
  color: 'secondary-light',
  children: <LocalizedText id="WEB_SAVE" />,
  type: 'submit',
}
